// useDownloadFile.ts
import { useCallback } from "react";

export function useDownloadFile() {
    return useCallback(async (url: string, filename = "file") => {
        console.log(111, url, filename)
        try {
            const res = await fetch(url);
            if (!res.ok) throw new Error("Failed to fetch file");

            const blob = await res.blob();

            // 自动识别文件类型并补后缀
            const mime = blob.type; // e.g. application/pdf
            const ext = mime.split("/")[1] || "pdf";

            const finalName = filename.includes(".")
                ? filename
                : `${filename}.${ext}`;

            const blobUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = finalName;
            a.click();
            URL.revokeObjectURL(blobUrl);
        } catch (err) {
            console.error("File download failed:", err);
        }
    }, []);
}
